import { httpClient } from '@/services/http/httpClient'

import type { FinancialDetails } from '@/tabs/shared/financialImpact/types'

type GetFinancialImpactByIdeaIdProps = {
  projectId: string
}

export const getFinancialImpactByProjectId = async ({
  projectId,
}: GetFinancialImpactByIdeaIdProps) => {
  const { data } = await httpClient.get<FinancialDetails[]>(
    `/projects/financial-details/getByProjectId/${projectId}`,
  )

  return data
}
